<template>
    <div v-if="loading" class="loading-overlay">
      <div class="loading-container">
        <div class="spinner mt-3"></div>
        <div class="loading-text">Seohan</div>
      </div>
    </div>
    <div class="container-fluid py-3 mt-2 ">
        <div class="">
        <p class="custom-text-h4 font-weight-bold text-black ma-2">Supply Performance</p>
        <p class="font-weight-bold ml-5 mt-0 text-gray">
          <v-icon icon="mdi-sort-reverse-variant" class="mr-2"></v-icon>Order Management >
          Supply Performance
        </p>
      </div>
      

      <v-row class="d-flex align-items-center mb-1">

        <v-col cols="3" class="pr-2 pl-0 ml-3">

            <div class="split-box1">
                <div class="label-box">Part Number</div>
                <div class="select-box">
                    <v-text-field
                    v-model="search.partNumber"
                    placeholder="Enter Part Number"
                    dense
                    outlined
                    class="custom-input mt-4"
                    variant="plain"
                    
                />
                </div>
            </div>
            
        </v-col>
        <!-- Part Name 입력 필드 -->
        <v-col cols="3" style ="padding-left: 0px;">

            <div class="split-box1">
                <div class="label-box">Part Name</div>
                <div class="select-box">
                    <v-text-field
                    v-model="search.partName"
                    placeholder="Enter Part Name"
                    dense
                    outlined
                    class="custom-input mt-4"
                    variant="plain"
                    
                />
                </div>
            </div>

        </v-col>

        <!-- Status 선택 필드 -->
            <!-- <v-menu offset-y >
                <template v-slot:activator="{ props }" >
                    <div class="custom-select" v-bind="props" >
                        <span class="custom-label4 font-weight-bold">Status</span>
                        <span class="custom-value">{{ search.status }}</span>
                    </div>
                </template>
                <v-list>
                    <v-list-item
                        v-for="(item, index) in statusOptions"
                        :key="index"
                        @click="search.status = item"
                    >
                        <v-list-item-title>{{ item }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu> -->
        <v-col cols="3" class="d-flex align-items-center">
            <!-- 라벨 -->
            <div class="label-box date-label-box mr-0">Date</div>

            <!-- 날짜 피커 -->
            <div class="d-flex align-items-center" style="gap: 8px; margin-bottom: 12px">
                <!-- 시작 날짜 -->
                <vue-datepicker 
                v-model="date1"
                class="bg-white custom-datepicker startDate"
                placeholder="Start Date"
                :text-input="textInputOptions"
                :is-24="false"
                :enable-time-picker="false"
                arrow-navigation
                format="yyyy-MM-dd"
                :max="date2"
                :auto-apply="true" 
                />

                <span>~</span>

                <!-- 종료 날짜 -->
                <vue-datepicker 
                v-model="date2"
                class="bg-white custom-datepicker"
                style="padding-right: 0px;"
                placeholder="End Date"
                :text-input="textInputOptions"
                :is-24="false"
                :enable-time-picker="false"
                arrow-navigation
                format="yyyy-MM-dd"
                :min="date1"
                :auto-apply="true" 
                />
            </div>
            </v-col>




        <v-spacer/>
        <!-- 검색 버튼 -->
        <v-col cols="auto" class="d-flex justify-end">
            <v-btn color="primary" class="search-btn" @click="handleSearch">
            <v-icon left>mdi-magnify</v-icon> Search
            </v-btn>
        </v-col>
        <v-col cols="auto" class="d-flex justify-end">
            <v-btn
                color="green"
                class="search-btn"
                @click="isGaAlCompany ? exportToExcelALGA() : exportToExcel()"
                :disabled="!isExcelEnabled"
                >
                <v-icon left class="mr-2">mdi-file-excel</v-icon> Excel

            </v-btn>
        </v-col>







          

        </v-row>
        <v-card class="custom-card" elevation="2" >
            <v-card-title class="custom-card-title py-1">
                <v-row class="w-100 align-center" no-gutters>
                    <v-col cols="auto">
                    <span class="text-white font-weight-bold">Performance</span>
                    </v-col>
                    <v-spacer />
                    <v-col cols="auto" v-if="isGaAlCompany">
                        <v-btn-toggle
                        v-model="viewMode"
                        mandatory
                        density="comfortable"
                        style="height: 30px;"
                    >
                        <v-btn
                        value="ALL"
                        :color="viewMode === 'ALL' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 50px; height: 26px;"
                        >
                        All
                        </v-btn>
                        <v-btn
                        value="AL"
                        :color="viewMode === 'AL' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 40px; height: 26px;"
                        >
                        AL
                        </v-btn>
                        <v-btn
                        value="GA"
                        :color="viewMode === 'GA' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 40px; height: 26px;"
                        >
                        GA
                        </v-btn>
                    </v-btn-toggle>
                    </v-col>
                    <v-col cols="auto" v-if="isAutoNtnCompany">
                        <v-btn-toggle
                        v-model="viewModeAUTONTN"
                        mandatory
                        density="comfortable"
                        style="height: 30px;"
                    >
                        <v-btn
                        value="ALL"
                        :color="viewModeAUTONTN === 'ALL' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 50px; height: 26px;"
                        >
                        All
                        </v-btn>
                        <v-btn
                        value="AUTO"
                        :color="viewModeAUTONTN === 'AUTO' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 40px; height: 26px;"
                        >
                        AUTO
                        </v-btn>
                        <v-btn
                        value="NTN"
                        :color="viewModeAUTONTN === 'NTN' ? 'green' : 'grey lighten-1'"
                        class="font-weight-bold"
                        style="min-width: 40px; height: 26px;"
                        >
                        NTN
                        </v-btn>
                    </v-btn-toggle>
                    </v-col>
                </v-row>
                </v-card-title>

            <div class="additional-content mt-3" style="padding-top: 3px; ">

            <v-data-table 
                :headers="headers" 
                :items="items" 
                :items-per-page = "-1"
                v-model:items-per-page="itemsPerPage"
                class="elevation-1 detail-table2 lift-up" 
                height="30vh"
                density="compact"
                @click:row="openDetailPanel"
                hover
                fixed-header
                >
                <template v-slot:bottom> </template>

                <template #item="{ item }">
                    <tr @click="openDetailPanel($event, { item })" style="cursor: pointer;">
                        <td>{{ item.productName }}</td>
                        <td>{{ item.productNumber }}</td>
                        <td>{{ formatNumber(item.quantity) }}</td>
                        <td>{{ formatNumber(item.returnedQty) }}</td>
                        <td class="font-weight-bold">{{ formatNumber(item.deliveredQty) }}</td>
                        <td>${{ formatNumber(item.deliveredAmount) }}</td>
                        <td>{{ formatNumber(item.finalQty || 0) }}</td> <!-- ✅ 없으면 0으로 -->
                        <td>${{ formatNumber(item.finalAmount || 0) }}</td> <!-- ✅ 없으면 0으로 -->
                    </tr>
                </template>

                </v-data-table>
            </div>

            
        </v-card>
        <v-card class="custom-card-2" elevation="2" style="margin-top:10px; margin-bottom: 1px; padding-top: 0px;">
    <!-- <p class="po-details-title" style="margin-bottom: 0px;">
        Performance Details <span v-if="selectedPoNumber">  {{ selectedPoNumber }}</span>
    </p> -->
    <v-card-title class="custom-card-title">
            Performance Details
    </v-card-title>
<div class=" pa-4">
    <div class="additional-content2 " style="padding-top: 1px;">
        <!-- ✅ details가 존재하지 않거나 비어있으면 기본 메시지 표시 -->
        <p v-if="!details || details.length === 0" class = "mt-5">Click product to view details.</p>

        <!-- ✅ details에 데이터가 있으면 테이블을 렌더링 -->
        <v-data-table 
            v-else
            :headers="detailHeaders"
            :items="details"
            :items-per-page = "-1"
            class="elevation-1 detail-table"
            height="30vh"
            density="compact"
            fixed-header
            hover
        >
        <template v-slot:bottom> </template>
        <template v-slot:item="props">
           
            <tr>
                <td>{{ props.item.deliveryDate }}</td>
                <td>{{ props.item.ioType }}</td>
                <td>{{ props.item.productNumber }}</td>
                <td>{{ props.item.productName }}</td>
                <td>{{ props.item.lotDate }}</td>
                <td>{{ formatNumber(props.item.quantity) }}</td>
                <td class="font-weight-bold">${{ formatNumber(props.item.cost) }}</td>
                <td>{{ props.item.location }}</td>
                <td>{{ props.item.asnNoDetail }}</td>
            </tr>
        </template>

        </v-data-table>
    </div>
</div>
</v-card>

    </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios"; // API 요청을 위해 axios 추가
import "@vuepic/vue-datepicker/dist/main.css";
import VueDatepicker from "@vuepic/vue-datepicker";

export default {
    components: {
            VueDatepicker,
            
        },
    data() {
        return {
            viewMode: 'ALL', // 기본 선택
            viewModeAUTONTN: 'ALL', // 기본 선택
            isExcelEnabled: true, // 엑셀 버튼 활성화 여부
            date1: this.getFirstDayOfMonth(), // 이번 달 1일
            date2: this.getToday(), // 오늘 날짜
            textInputOptions: {
                openMenu: true, // 클릭 시 자동으로 열림
                enterSubmit: true, // 엔터 입력 가능
            },
            search: {
                partNumber: "",
                partName: "",
                status: "ALL", // 기본값 ALL
            },
            statusOptions: ["ALL", "Not Complete", "Complete"], // Status 옵션
            headers: [
                { title: "Part Name", key: "productName", align: "center", sortable: false },
                { title: "Part Number", key: "productNumber", align: "center", sortable: false },
                { title: "Quantity", key: "quantity", align: "center", sortable: false },
                { title: "Returned Qty", key: "returnedQty", align: "center", sortable: false },       // 반송 수량
                { title: "Delivered Qty", key: "deliveredQty", align: "center", sortable: false },     // 실납품 수량
                { title: "Delivered Amount", key: "deliveredAmount", align: "center", sortable: false }, // 실납품 금액
                { title: "Final Qty", key: "finalQty", align: "center", sortable: false }, // 실납품 금액
                { title: "Final Amount", key: "finalAmount", align: "center", sortable: false } // 실납품 금액

            ],
            detailHeaders: [
                { title: "Receive Date", key: "receiveDate", align: "center", sortable: false },
                { title: "Inbound/Outbound", key: "inoutType", align: "center", sortable: false }, // 입출구분
                { title: "Part Number", key: "productNumber", align: "center", sortable: false },
                { title: "Part Name", key: "productName", align: "center", sortable: false },
                { title: "LOT Date", key: "lotDate", align: "center", sortable: false },
                { title: "Quantity", key: "quantity", align: "center", sortable: false },
                { title: "Cost", key: "cost", align: "center", sortable: false },
                { title: "Location", key: "location", align: "center", sortable: false },
                { title: "ASN No. Detail", key: "asnDetail", align: "center", sortable: false },
            ],
            loading: false,
            items: [],
            details: [], // ✅ 초기값을 빈 배열로 설정
            selectedPoNumber: "", // ✅ 선택한 PO 번호 저장
            isHistoryModalVisible: false,  // ✅ 모달 상태
            partDetail: {},  // ✅ 선택된 부품 정보
            partHistory: [],  // ✅ 부품 히스토리
            warehouseNameMap: {},
            gaAlCompanyList: [],
            autoNtnCompanyList: [],
        };
    },
    computed: {
        // filteredItems() {
        //     return this.items.filter(item => 
        //         item.poNumber.toLowerCase().includes(this.search.toLowerCase())
        //     );
        // },
        normalizedUsername() {
            return String(this.username || "").toUpperCase();
        },
        isGaAlCompany() {
            return this.gaAlCompanyList
                .map(code => String(code).toUpperCase())
                .includes(this.normalizedUsername);
        },
        isAutoNtnCompany() {
            return this.autoNtnCompanyList
                .map(code => String(code).toUpperCase())
                .includes(this.normalizedUsername);
        },
        ...mapState({
        username: (state) => state.username, // Vuex 상태에서 username 가져오기
        userName: (state) => state.userName
        }),
    },
    watch: {
        date1() {
            this.isExcelEnabled = false;
        },
        date2() {
            this.isExcelEnabled = false;
        },
        viewMode(newValue) {
            const statusMapping = {
            "ALL": 0,
            "Complete": 1,
            "Not Complete": 2
            };
            const statusCode = statusMapping[this.search.status] || 0;

            const params = {
            part_number: this.search.partNumber,
            part_name: this.search.partName,
            status: statusCode,
            username: this.username,
            date1: this.formatDateToYYYYMMDD(this.date1),
            date2: this.formatDateToYYYYMMDD(this.date2)
            };

            if (newValue === 'ALL') {
            this.getfilterData();
            } else if (newValue === 'GA') {
            this.getGaFilterData(params);
            } else if (newValue === 'AL') {
            this.getAlFilterData(params);
            }
        },
        viewModeAUTONTN(newValue) {
            const statusMapping = {
            "ALL": 0,
            "Complete": 1,
            "Not Complete": 2
            };
            const statusCode = statusMapping[this.search.status] || 0;

            const params = {
            part_number: this.search.partNumber,
            part_name: this.search.partName,
            status: statusCode,
            username: this.username,
            date1: this.formatDateToYYYYMMDD(this.date1),
            date2: this.formatDateToYYYYMMDD(this.date2)
            };

            if (newValue === 'ALL') {
            this.getfilterData();
            } else if (newValue === 'AUTO') {
            this.getAUTOFilterData(params);
            } else if (newValue === 'NTN') {
            this.getNTNFilterData(params);
            }
        }
    },
    methods: {
        async fetchSupplyPerformanceCompanyFeatures() {
            try {
                const response = await axios.get("/api/getSupplyPerformanceCompanyFeatures");
                const rows = response.data.data || [];

                this.gaAlCompanyList = rows
                    .filter(row => String(row.USE_GA_AL_CATEGORY || "").trim().toUpperCase() === "Y")
                    .map(row => String(row.CUST_CD || row.ASDES || row).trim())
                    .filter(Boolean);

                this.autoNtnCompanyList = rows
                    .filter(row => String(row.USE_AUTO_NTN || "").trim().toUpperCase() === "Y")
                    .map(row => String(row.CUST_CD || row.ASDES || row).trim())
                    .filter(Boolean);
            } catch (error) {
                console.error("getSupplyPerformanceCompanyFeatures API 호출 오류:", error);
                this.gaAlCompanyList = [];
                this.autoNtnCompanyList = [];
            }
        },
        async fetchWarehouseNames() {
            try {
                const response = await axios.get("/api/getWarehouseName");
                const rows = response.data.data || [];

                this.warehouseNameMap = rows.reduce((map, row) => {
                    const code = String(row.ASDES || row.CODE || row.CODE_CD || row.value || "").trim();
                    const name = String(row.AREF1 || row.name || row.ASDES || "").trim();

                    if (code && name) {
                        map[code] = name;
                    }

                    return map;
                }, {});
            } catch (error) {
                console.error("getWarehouseName API 호출 오류:", error);
                this.warehouseNameMap = {};
            }
        },
        formatDeliveryLocation(carrierNm, rackType = "") {
            const code = String(carrierNm || "").trim();
            const location = this.warehouseNameMap[code] || code || "-";
            const isSample = String(rackType || "").trim().toLowerCase() === "sample";

            if (isSample && ["AB", "BB"].includes(code)) {
                return `${location} - Sample`;
            }

            return location;
        },
        async getAUTOFilterData(params) {
            this.details = [];
            try {
                this.loading = true;

                // 기본 날짜 체크
                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }
                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }

                // Status 매핑
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0;

                // 1차: 일반 Performance 데이터
                const response = await axios.get("/api/getFilteredSupplyPerformance", {
                    params: {
                        part_number: params.part_number,
                        part_name: params.part_name,
                        status: statusCode,
                        username: params.username,
                        date1: params.date1,
                        date2: params.date2
                    }
                });

                // 2차: Final 데이터
                const response2 = await axios.get("/api/getFilteredSupplyPerformanceFinal", {
                    params: {
                        part_number: params.part_number,
                        part_name: params.part_name,
                        status: statusCode,
                        username: params.username,
                        date1: params.date1,
                        date2: params.date2
                    }
                });

                const groupedMap = new Map();

                if (response.data.success) {
                    const rawData = response.data.supplyPerformance
                        .filter(order => order.CUST_CD === 'Z0013'); // ✅ 여기서 필터링

                    rawData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.quantity += quantity;
                            existing.deliveredQty += quantity;
                            existing.deliveredAmount += amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity,
                                returnedQty: 0,
                                deliveredQty: quantity,
                                deliveredAmount: amount,
                                finalQty: 0,
                                finalAmount: 0
                            });
                        }
                    });
                    this.isExcelEnabled = true;
                }

                if (response2.data.success) {
                    const finalData = response2.data.supplyPerformance
                        .filter(order => order.CUST_CD === 'Z0013'); // ✅ 여기서도 필터링

                    finalData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.finalQty = (existing.finalQty || 0) + quantity;
                            existing.finalAmount = (existing.finalAmount || 0) + amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity: 0,
                                returnedQty: 0,
                                deliveredQty: 0,
                                deliveredAmount: 0,
                                finalQty: quantity,
                                finalAmount: amount
                            });
                        }
                    });
                }

                this.items = Array.from(groupedMap.values());
            } catch (error) {
                console.error("❌ Error fetching AUTO filter data:", error);
                this.items = [];
            } finally {
                this.loading = false;
            }
        },
        async getNTNFilterData(params) {
            this.details = [];
            try {
                this.loading = true;

                // 기본 날짜 체크
                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }
                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }

                // Status 매핑
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0;

                // 1차: 일반 Performance 데이터
                const response = await axios.get("/api/getFilteredSupplyPerformance", {
                    params: {
                        part_number: params.part_number,
                        part_name: params.part_name,
                        status: statusCode,
                        username: params.username,
                        date1: params.date1,
                        date2: params.date2
                    }
                });

                // 2차: Final 데이터
                const response2 = await axios.get("/api/getFilteredSupplyPerformanceFinal", {
                    params: {
                        part_number: params.part_number,
                        part_name: params.part_name,
                        status: statusCode,
                        username: params.username,
                        date1: params.date1,
                        date2: params.date2
                    }
                });

                const groupedMap = new Map();

                if (response.data.success) {
                    const rawData = response.data.supplyPerformance
                        .filter(order => order.CUST_CD === 'Z0014'); // ✅ 여기서 필터링

                    rawData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.quantity += quantity;
                            existing.deliveredQty += quantity;
                            existing.deliveredAmount += amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity,
                                returnedQty: 0,
                                deliveredQty: quantity,
                                deliveredAmount: amount,
                                finalQty: 0,
                                finalAmount: 0
                            });
                        }
                    });
                    this.isExcelEnabled = true;
                }

                if (response2.data.success) {
                    const finalData = response2.data.supplyPerformance
                        .filter(order => order.CUST_CD === 'Z0014'); // ✅ 여기서도 필터링

                    finalData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.finalQty = (existing.finalQty || 0) + quantity;
                            existing.finalAmount = (existing.finalAmount || 0) + amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity: 0,
                                returnedQty: 0,
                                deliveredQty: 0,
                                deliveredAmount: 0,
                                finalQty: quantity,
                                finalAmount: amount
                            });
                        }
                    });
                }

                this.items = Array.from(groupedMap.values());
            } catch (error) {
                console.error("❌ Error fetching AUTO filter data:", error);
                this.items = [];
            } finally {
                this.loading = false;
            }
        },
        handleSearch() {
            const statusMapping = {
                "ALL": 0,
                "Complete": 1,
                "Not Complete": 2
            };

            const statusCode = statusMapping[this.search.status] || 0;

            const params = {
                part_number: this.search.partNumber,
                part_name: this.search.partName,
                status: statusCode,
                username: this.username,
                date1: this.formatDateToYYYYMMDD(this.date1),
                date2: this.formatDateToYYYYMMDD(this.date2)
            };

            if (this.isGaAlCompany && this.viewMode === 'GA') {
                this.getGaFilterData(params);
            } else if (this.isGaAlCompany && this.viewMode === 'AL') {
                this.getAlFilterData(params);
            } else if (this.isAutoNtnCompany && this.viewModeAUTONTN === 'AUTO') {
                this.getAUTOFilterData(params);
            } else if (this.isAutoNtnCompany && this.viewModeAUTONTN === 'NTN') {
                this.getNTNFilterData(params);
            } else {
                this.getfilterData();
            }
        },
        
        async exportToExcel() {
            if (!this.items.length) {
                alert("No data to export.");
                return;
            }

            this.loading = true;
            this.detailsForExcel = [];
            try {
                // ✅ 1차: 디테일 데이터 먼저 조회
                const response = await axios.get(`/api/getPerformanceDetailForExcel`, {
                params: {
                    username: this.username,
                    date1: this.formatDateToYYYYMMDD(this.date1),
                    date2: this.formatDateToYYYYMMDD(this.date2),
                }
                });
                //console.log('hi',response.data)
                if (response.data.success) {
                this.detailsForExcel = response.data.details.map((row, index) => {
                const location = this.formatDeliveryLocation(row.CARRIER_NM, row.RACK_TYPE);
                    return {
                    id: index + 1,
                    deliveryDate: this.formatDate(row.RP_YMD),
                    ioType: row.INOUT_GB || "IN",
                    productNumber: this.formatItemNumber(row.ITMNO),
                    productName: row.ITM_NM,
                    lotDate: this.formatDate(row.BOX_LOT),
                    quantity: row.SHIP_QTY || 0,
                    cost: row.RCV_AMT || 0,
                    location,
                    asnNoDetail: row.INVO_NO || "-",
                    etc: row.REMK2 || ""
                    };
                });
                } else {
                this.detailsForExcel = [];
                }
                //console.log("looking" , this.items, this.detailsForExcel)
                // ✅ 2차: export 요청
                const exportRes = await axios.post("/api/exportExcelPerformance", {
                    userName: this.userName,
                    items: this.items,
                    details: this.detailsForExcel,
                    date1: this.formatDateToYYYYMMDD(this.date1),
                    date2: this.formatDateToYYYYMMDD(this.date2),
                }, {
                responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([exportRes.data]));
                const link = document.createElement('a');
                link.href = url;
                const today = new Date();
                const todayFormatted = `${today.getFullYear().toString().slice(2)}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;

                const fileName = `SupplyPerformance_${todayFormatted}_${this.formatDateToYYYYMMDD(this.date1)}~${this.formatDateToYYYYMMDD(this.date2)}.xlsx`;

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();

            } catch (error) {
                console.error("❌ Excel export failed:", error);
            } finally {
                this.loading = false;
            }
        },
        async exportToExcelALGA() {
            if (!this.items.length) {
                alert("No data to export.");
                return;
            }

            this.loading = true;
            this.detailsForExcel = [];
            try {
                // ✅ 1차: 디테일 데이터 먼저 조회
                const response = await axios.get(`/api/getPerformanceDetailForExcelALGA`, {
                params: {
                    username: this.username,
                    date1: this.formatDateToYYYYMMDD(this.date1),
                    date2: this.formatDateToYYYYMMDD(this.date2),
                }
                });
                //console.log('hi',response.data)
                if (response.data.success) {
                this.detailsForExcel = response.data.details.map((row, index) => {
                const location = this.formatDeliveryLocation(row.CARRIER_NM, row.RACK_TYPE);

                    return {
                    id: index + 1,
                    deliveryDate: this.formatDate(row.RP_YMD),
                    ioType: row.INOUT_GB || "IN",
                    productNumber: this.formatItemNumber(row.ITMNO),
                    productName: row.ITM_NM,
                    lotDate: this.formatDate(row.BOX_LOT),
                    quantity: row.SHIP_QTY || 0,
                    cost: row.RCV_AMT || 0,
                    location,
                    asnNoDetail: row.INVO_NO || "-",
                    etc: row.REMK2 || "",
                    BL_NO: row.BL_NO
                    };
                });
                } else {
                this.detailsForExcel = [];
                }
                //console.log("looking" , this.items, this.detailsForExcel)
                // ✅ 2차: export 요청
                const exportRes = await axios.post("/api/exportExcelPerformanceALGA", {
                    userName: this.userName,
                    items: this.items,
                    details: this.detailsForExcel,
                    date1: this.formatDateToYYYYMMDD(this.date1),
                    date2: this.formatDateToYYYYMMDD(this.date2),
                }, {
                responseType: 'blob'
                });

                const url = window.URL.createObjectURL(new Blob([exportRes.data]));
                const link = document.createElement('a');
                link.href = url;
                const today = new Date();
                const todayFormatted = `${today.getFullYear().toString().slice(2)}${String(today.getMonth() + 1).padStart(2, '0')}${String(today.getDate()).padStart(2, '0')}`;

                const fileName = `SupplyPerformance_${todayFormatted}_${this.formatDateToYYYYMMDD(this.date1)}~${this.formatDateToYYYYMMDD(this.date2)}.xlsx`;

                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
                link.remove();

            } catch (error) {
                console.error("❌ Excel export failed:", error);
            } finally {
                this.loading = false;
            }
        },


        getFirstDayOfMonth() {
            const now = new Date();
            return new Date(now.getFullYear(), now.getMonth(), 1); // 이번 달 1일
        },
        getToday() {
            return new Date(); // 오늘 날짜
        },
        formatNumber(value) {
            if (!value) return "0"; // 값이 없으면 0 리턴
            return Number(value).toLocaleString(); // 천 단위 콤마 추가
        },
        formatItemNumber(rawItemNo) {
            const cleaned = rawItemNo.replace(/-/g, "");
            if (!isNaN(parseFloat(cleaned.charAt(0))) && isFinite(cleaned.charAt(0))) {
            return cleaned.substring(0, 5) + "-" + cleaned.substring(5);
            } else {
            return cleaned.substring(0, 6) + "-" + cleaned.substring(6);
            }
        },
        async openDetailPanel(event, { item }) {
            this.details = []; // ✅ 기존 데이터 초기화
            this.loading = true;
            //console.log('📌 Detail 조회 시작');
            try {
                let apiUrl = '/api/getPerformanceDetail';

                // 회사코드가 P1300 또는 P0801일 때만 viewMode 고려
                if (this.isGaAlCompany) {
                if (this.viewMode === 'AL') {
                    apiUrl = '/api/getPerformanceDetailAL';
                } else if (this.viewMode === 'GA') {
                    apiUrl = '/api/getPerformanceDetailGA';
                }
                }

                const response = await axios.get(apiUrl, {
                params: {
                    item_no: item.productNumber,
                    username: this.username,
                    date1: this.formatDateToYYYYMMDD(this.date1),
                    date2: this.formatDateToYYYYMMDD(this.date2),
                }
                });

                //console.log("📦 디테일 데이터:", response.data);

                if (response.data.success) {
                    this.details = response.data.details.map((row, index) => {
                        const location = this.formatDeliveryLocation(row.CARRIER_NM, row.RACK_TYPE);

                        return {
                            id: index + 1,
                            deliveryDate: this.formatDate(row.RP_YMD),        // ✅ Receive Date
                            ioType: row.INOUT_GB || "IN",                      // ✅ 입출구분
                            productNumber: this.formatItemNumber(row.ITMNO),                        // ✅ Product Number
                            productName: row.ITM_NM,                          // ✅ Product Name
                            lotDate: this.formatDate(row.BOX_LOT),            // ✅ LOT Date
                            quantity: row.SHIP_QTY || 0,                       // ✅ Quantity
                            cost: row.RCV_AMT || 0,                            // ✅ Cost (변경됨)
                            location,                                          // ✅ 위치 (변환된 값)
                            asnNoDetail: row.INVO_NO || "-",                // ✅ ASN_NO_Detail
                            etc: row.REMK2 || ""                               // ✅ ETC
                        };
                    });
                    this.loading = false;

                } else {
                    this.details = [];
                    this.loading = false;

                }
            } catch (error) {
                console.error("❌ Error fetching performance detail:", error);
                this.loading = false;

            }
        },


        openDetailModal(event, { item }) {
            this.partDetail = item.poNumber; // ✅ 선택한 poNumber 저장
            this.isHistoryModalVisible = true; // ✅ 모달 열기
        },
            
        addItem() {
            //console.log("새로운 PO 추가 기능 필요");
        },
        async getOrderStatus() {
            try {
                this.loading = true; // API 호출 중 로딩 상태 활성화
                const response = await axios.get("/api/getOrderStatus", {
                    params: { username: this.username }, // 요청 시 username 전달
                });

                if (response.data.success) {
                    this.items = response.data.orders.map(order => {
                        const receivedQty = parseInt(order.RP_QTY, 10) || 0;
                        const poQty = parseInt(order.PO_QTY, 10) || 0;
                        const remainQty = Math.max(poQty - receivedQty, 0); // 음수면 0으로 처리
                        const status = remainQty <= 0 ? "Complete" : "Not Complete";
                        const receivePercent = poQty > 0 ? ((receivedQty / poQty) * 100).toFixed(2) + "%" : "0%"; // ✅ 퍼센트 계산

                        return {
                            poNumber: order.PO_NO,  // PO Number
                            poDate: this.formatDate(order.PO_YMD),  // PO Date
                            poQty: order.PO_QTY,  // PO QTY
                            receivedQty: order.RP_QTY,  // Received QTY
                            receivePercent,
                            remainQty: remainQty,  // Remain QTY (음수 방지)
                            status: status,  // Status (remain이 0이면 Complete)
                        };
                    });
                } else {
                    console.error("Failed to fetch order status");
                    this.items = []; // 실패 시 빈 배열
                }
            } catch (error) {
                console.error("Error fetching order status:", error);
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        async getfilterData() {
            this.details = [];
            try {
                this.loading = true; // 로딩 상태 활성화

                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }

                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }
                // ✅ Status 값을 숫자로 변환 (ALL: 0, Complete: 1, Not Complete: 2)
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0; // 기본값 0 (ALL)

                // API 요청
                const response = await axios.get("/api/getFilteredSupplyPerformance", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });

                const response2 = await axios.get("/api/getFilteredSupplyPerformanceFinal", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });
                //console.log("🔍 검색 조건:", response);
                //console.log("🔍 검색 조건 마감 가격:", response2);
                const groupedMap = new Map();

                if (response.data.success) {
                    const rawData = response.data.supplyPerformance;

                    rawData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.quantity += quantity;
                            existing.deliveredQty += quantity;
                            existing.deliveredAmount += amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity,
                                returnedQty: 0,
                                deliveredQty: quantity,
                                deliveredAmount: amount,
                                finalQty: 0,         // 먼저 초기화
                                finalAmount: 0
                            });
                        }
                    });
                    this.isExcelEnabled = true; // ✅ 검색 후 엑셀 버튼 다시 활성화

                }

                if (response2.data.success) {
                    const finalData = response2.data.supplyPerformance;

                    finalData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.finalQty = (existing.finalQty || 0) + quantity;
                            existing.finalAmount = (existing.finalAmount || 0) + amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity: 0,
                                returnedQty: 0,
                                deliveredQty: 0,
                                deliveredAmount: 0,
                                finalQty: quantity,
                                finalAmount: amount
                            });
                        }
                    });
                }


                // ✅ 이제 여기서 최종 items로 세팅
                this.items = Array.from(groupedMap.values());
                //console.log('✅ 최종 items:', this.items);

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.warn("⚠ No matching orders found.");
                    this.items = []; // ✅ 404일 경우 테이블 클리어
                } else {
                    console.error("❌ Error fetching filtered order status:", error);
                }
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        async getGaFilterData() {
            this.details = [];
            try {
                this.loading = true; // 로딩 상태 활성화

                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }

                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }
                // ✅ Status 값을 숫자로 변환 (ALL: 0, Complete: 1, Not Complete: 2)
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0; // 기본값 0 (ALL)

                // API 요청
                const response = await axios.get("/api/getGaFilterData", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });

                const response2 = await axios.get("/api/getFilteredSupplyPerformanceGAFinal", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });
                //console.log("🔍 검색 조건:", response);
                //console.log("🔍 검색 조건 마감 가격:", response2);
                const groupedMap = new Map();

                if (response.data.success) {
                    const rawData = response.data.supplyPerformance;

                    rawData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.quantity += quantity;
                            existing.deliveredQty += quantity;
                            existing.deliveredAmount += amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity,
                                returnedQty: 0,
                                deliveredQty: quantity,
                                deliveredAmount: amount,
                                finalQty: 0,         // 먼저 초기화
                                finalAmount: 0
                            });
                        }
                    });
                    this.isExcelEnabled = true; // ✅ 검색 후 엑셀 버튼 다시 활성화

                }

                if (response2.data.success) {
                    const finalData = response2.data.supplyPerformance;

                    finalData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.finalQty = (existing.finalQty || 0) + quantity;
                            existing.finalAmount = (existing.finalAmount || 0) + amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity: 0,
                                returnedQty: 0,
                                deliveredQty: 0,
                                deliveredAmount: 0,
                                finalQty: quantity,
                                finalAmount: amount
                            });
                        }
                    });
                }


                // ✅ 이제 여기서 최종 items로 세팅
                this.items = Array.from(groupedMap.values());
                //console.log('✅ 최종 items:', this.items);

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.warn("⚠ No matching orders found.");
                    this.items = []; // ✅ 404일 경우 테이블 클리어
                } else {
                    console.error("❌ Error fetching filtered order status:", error);
                }
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        async getAlFilterData() {
            this.details = [];
            try {
                this.loading = true; // 로딩 상태 활성화

                if (!this.date1 || !this.date2) {
                    alert("⚠️ Both Start Date and End Date are required.");
                    this.loading = false;
                    return;
                }

                if (new Date(this.date2) < new Date(this.date1)) {
                    alert("⚠️ End Date cannot be earlier than Start Date.");
                    this.loading = false;
                    return;
                }
                // ✅ Status 값을 숫자로 변환 (ALL: 0, Complete: 1, Not Complete: 2)
                const statusMapping = {
                    "ALL": 0,
                    "Complete": 1,
                    "Not Complete": 2
                };
                const statusCode = statusMapping[this.search.status] || 0; // 기본값 0 (ALL)

                // API 요청
                const response = await axios.get("/api/getAlFilterData", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });

                const response2 = await axios.get("/api/getFilteredSupplyPerformanceALFinal", {
                    params: {
                        part_number: this.search.partNumber,
                        part_name: this.search.partName,  // Part Name 전달
                        status: statusCode,  // 숫자로 변환한 Status 전달
                        username: this.username ,
                        date1: this.formatDateToYYYYMMDD(this.date1), // 변환된 date1
                        date2: this.formatDateToYYYYMMDD(this.date2), // 변환된 date2
                    }
                });
                //console.log("🔍 검색 조건:", response);
                //console.log("🔍 검색 조건 마감 가격:", response2);
                const groupedMap = new Map();

                if (response.data.success) {
                    const rawData = response.data.supplyPerformance;

                    rawData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.quantity += quantity;
                            existing.deliveredQty += quantity;
                            existing.deliveredAmount += amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity,
                                returnedQty: 0,
                                deliveredQty: quantity,
                                deliveredAmount: amount,
                                finalQty: 0,         // 먼저 초기화
                                finalAmount: 0
                            });
                        }
                    });
                    this.isExcelEnabled = true; // ✅ 검색 후 엑셀 버튼 다시 활성화

                }

                if (response2.data.success) {
                    const finalData = response2.data.supplyPerformance;

                    finalData.forEach(order => {
                        const key = order.item_no;
                        const quantity = Number(order.total_ship_qty || 0);
                        const unitPrice = Number(order.uprc_amt || 0);
                        const amount = quantity * unitPrice;

                        if (groupedMap.has(key)) {
                            const existing = groupedMap.get(key);
                            existing.finalQty = (existing.finalQty || 0) + quantity;
                            existing.finalAmount = (existing.finalAmount || 0) + amount;
                        } else {
                            groupedMap.set(key, {
                                productName: order.item_nm,
                                productNumber: order.item_no,
                                quantity: 0,
                                returnedQty: 0,
                                deliveredQty: 0,
                                deliveredAmount: 0,
                                finalQty: quantity,
                                finalAmount: amount
                            });
                        }
                    });
                }


                // ✅ 이제 여기서 최종 items로 세팅
                this.items = Array.from(groupedMap.values());
                //console.log('✅ 최종 items:', this.items);

            } catch (error) {
                if (error.response && error.response.status === 404) {
                    console.warn("⚠ No matching orders found.");
                    this.items = []; // ✅ 404일 경우 테이블 클리어
                } else {
                    console.error("❌ Error fetching filtered order status:", error);
                }
            } finally {
                this.loading = false; // API 호출 완료 후 로딩 상태 해제
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            const strDate = dateString.toString();
            return `${strDate.substring(0, 4)}-${strDate.substring(4, 6)}-${strDate.substring(6, 8)}`;
        },
        formatDateToYYYYMMDD(date) {
            if (!date) return ""; // 날짜가 없을 경우 빈 값 반환
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0"); // 두 자리 숫자로 변환
            const day = String(d.getDate()).padStart(2, "0"); // 두 자리 숫자로 변환
            return `${year}${month}${day}`; // YYYYMMDD 형식으로 반환
        },
    },

    async mounted() {
        await Promise.all([
            this.fetchSupplyPerformanceCompanyFeatures(),
            this.fetchWarehouseNames()
        ]);
        this.getfilterData();
    }
}
</script>


<style scoped>
.modal-dialog {
  margin-top: 1000px; /* 원하는 값으로 조정 (기본값: auto) */
}

.custom-select {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 21px 20px;
    cursor: pointer;
    font-size: 16px;
    width: 250px;
    }
.custom-input {
    flex: 1;
    border: none;
    outline: none;
    background: transparent;
    padding-left: 12px;
    }

    .custom-value {
    flex: 1;
    text-align: left;
    color: #374151;
    padding-left: 20px;
    }

    /* ✅ Vuetify 기본 입력 필드 테두리, 그림자 제거 */
    .custom-input .v-input__control {
    border: none !important;
    box-shadow: none !important;
    background: transparent !important;
    min-height: 0 !important; /* ✅ 불필요한 높이 제거 */
    height: 100% !important;
    }

    /* ✅ 숫자 필드의 기본 스핀 버튼 완전 제거 */
    .custom-input input {
    -moz-appearance: none !important; /* Firefox */
    -webkit-appearance: none !important; /* Chrome, Safari */
    appearance: none !important;
    height: auto !important;
    min-height: unset !important;
    padding: 0 !important;
    text-align: left;
    background: transparent !important; /* ✅ 배경 투명화 */
    border: none !important; /* ✅ 테두리 제거 */
    box-shadow: none !important; /* ✅ 불필요한 박스 제거 */
    }

    /* ✅ Vuetify에서 자동 생성되는 불필요한 UI 요소 제거 */
    .custom-input .v-input__control::before,
    .custom-input .v-input__control::after {
    display: none !important;
    box-shadow: none !important;
    border: none !important;
    }

    /* ✅ v-text-field 내부 입력 필드 정렬 */
    .custom-input .v-input__control {
    display: flex !important;
    align-items: center !important;
    }

    /* ✅ 불필요한 여백 제거 */
    .custom-input input {
    margin: 0 !important;
    padding: 0 !important;
    }
    
 .custom-label2 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }

    .custom-label2::after {
    content: "";
    position: absolute;
    left: 10vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }

    .custom-label3 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }

    .custom-label3::after {
    content: "";
    position: absolute;
    left: 12vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }
    .custom-label4 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }
    .custom-label5 {
    color: #6b7280;
    font-weight: 500;
    margin-right: 12px;
    position: relative;
    padding-right: 12px;
    }


    .custom-label4::after {
    content: "";
    position: absolute;
    left: 8vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 180%;
    background-color: #cccccc;
    }

    .custom-label5::after {
    content: "";
    position: absolute;
    left: 6.5vh;
    top: 50%;
    transform: translateY(-50%);
    width: 2px;
    height: 170%;
    background-color:  #cccccc;
    }

    .container-input {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 310px;
    height: 45px;
    }
    .container-input2 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 80px;
    height: 45px;
    }
    .container-input3 {
    display: flex;
    align-items: center;
    border: 1px solid #d1d5db;
    background-color: white;
    border-radius: 4px;
    padding: 12px 15px;
    font-size: 16px;
    width: 293px;
    height: 45px;
    }
.custom-width {
    max-width: 300px;
}

/* 배경색 적용 */
.custom-bg ::v-deep(.v-input__control) {
    background-color: rgb(255, 255, 255) !important;
}



.data-table-row:hover {
    background-color: #dfffdf;
    cursor: pointer;
}

:deep() .v-data-table thead th {
    font-weight: bold !important; /* 헤더 텍스트 굵게 */
    text-align: center; /* 중앙 정렬 */
}


:deep() .v-table .v-table__wrapper > table > thead > tr > th {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
:deep() .v-table .v-table__wrapper > table > tbody > tr > td {
    border: thin solid rgba(var(--v-border-color), var(--v-border-opacity));
}
.custom-text-h4 {
        font-size: 3rem !important;
        font-weight: 400;
        line-height: 2.5rem;
        text-transform: none !important;
        /* -webkit-text-stroke: 1px black; */
    }
    .custom-font{
    font-size: 35px;
}
.section-divider {
  border: none;
  border-top: 1px solid #000000; /* 회색 선 */
  margin: 20px 0;
  margin-top: 0px;
}

:deep() .v-data-table thead th {
  background-color: #e3f2fd !important;
  font-weight: bold !important;
  text-align: center;
}

/* 줄무늬 */

:deep() .v-data-table tbody td:nth-child(6) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(5) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(4) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(3) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(2) {
  text-align: Center;
}
:deep() .v-data-table tbody td:nth-child(1) {
  text-align: Center;
}


.status-chip {
  height: 26px !important;         /* 칩 높이 */
  padding: 0 8px;       /* 좌우 패딩 */
  font-size: 18px !important;      /* 글자 크기 */
  border-radius: 2px;   /* 둥글기 */
  line-height: 20px;    /* 텍스트 중앙 정렬 */
  text-align: center;

}
/* 헤더(TH) 너비 설정 */
:deep() .v-data-table thead th:nth-child(1) {
  width: 160px !important;
}
:deep() .v-data-table thead th:nth-child(2) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(3) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(4) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(5) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(6) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(7) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(8) {
  width: 150px !important;
}
:deep() .v-data-table thead th:nth-child(9) {
  width: 150px !important;
}
/* 본문(TD)도 맞춰서 너비 설정 */
:deep() .v-data-table tbody td:nth-child(1) {
  width: 120px !important;
}
:deep() .v-data-table tbody td:nth-child(2) {
  width: 100px !important;
}
:deep() .v-data-table tbody td:nth-child(3) {
  width: 110px !important;
}
:deep() .v-data-table tbody td:nth-child(4) {
  width: 130px !important;
}
:deep() .v-data-table tbody td:nth-child(5) {
  width: 50px !important;
}
:deep() .v-data-table tbody td:nth-child(6) {
  width: 50px !important;
}
:deep() .v-data-table tbody td:nth-child(7) {
  width: 50px !important;
}
:deep() .v-data-table tbody td:nth-child(8) {
  width: 50px !important;
}
:deep() .v-data-table thead th {
  font-size: 14px !important; /* 헤더 텍스트 크기 증가 */
  font-weight: bold !important;
}

:deep() .v-data-table tbody td {
  font-size: 15px !important; /* 본문 텍스트 크기 증가 */
  font-weight: 500;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 9999;
}
.loading-container {
  display: flex;
  align-items: center;
  gap: 15px; /* 스피너와 텍스트 간격 */
}

/* ✅ 빙글빙글 도는 스피너 */
.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(0, 123, 255, 0.3);
  border-top: 5px solid #007bff;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* ✅ 스피너 애니메이션 */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/* ✅ 출렁이는 색상 변화 효과 */
.loading-text {
  font-size: 64px;
  font-weight: bold;
  text-transform: uppercase;
  background: linear-gradient(120deg, #ffffff, #007bff, #ffffff);
  background-size: 200% 200%;
  -webkit-background-clip: text;
  color: transparent;
  animation: waveColor 3s ease-in-out infinite;
}

/* ✅ 출렁이는 애니메이션 */
@keyframes waveColor {
  0% {
    background-position: 0% 70%;
  }
  50% {
    background-position: 100% 30%;
  }
  100% {
    background-position: 0% 70%;
  }
}

.custom-card {
  width: 100%; /* 너비 조절 */
  height: 37vh; /* 높이 조절 */
}
.custom-card-2 {
  width: 100%; /* 원하는 너비로 조정 가능 */
  height: 38vh; /* 높이 조정 가능 */
  margin: 20px auto; /* 가운데 정렬 */
  text-align: center;
  background-color: #ffffff; /* 배경색 추가 */
}

/* ✅ 추가적인 컨텐츠 스타일 */
.additional-content {
    padding: 20px;

  font-size: 16px;
  color: #333;
}
.additional-content2 {
  font-size: 16px;
  color: #333;
}
:deep(.detail-table .v-data-table-header th) {
    font-size: 10px !important; /* ✅ 헤더 글자 크기 줄이기 */
    font-weight: 500 !important;
    text-align: center;
    width: 100vh !important;
}
:deep(.status-cell) {
    text-align: center !important;
    justify-content: center;
    display: flex;
    align-items: center;
}

/* :deep(.detail-table thead th:nth-child(1)) { width: 10vh !important; }
:deep(.detail-table thead th:nth-child(2)) { width: 120vh !important; }
:deep(.detail-table thead th:nth-child(3)) { width: 140vh !important; }
:deep(.detail-table thead th:nth-child(4)) { width: 180vh !important; }
:deep(.detail-table thead th:nth-child(5)) { width: 130vh !important; }
:deep(.detail-table thead th:nth-child(6)) { width: 130vh !important; }
:deep(.detail-table thead th:nth-child(7)) { width: 140vh !important; }
:deep(.detail-table thead th:nth-child(8)) { width: 140vh !important; }
:deep(.detail-table thead th:nth-child(9)) { width: 100vh !important; } */


/* detail-table 숫자 컬럼 오른쪽 정렬 */
:deep(.detail-table tbody td:nth-child(6)),
:deep(.detail-table tbody td:nth-child(7)){
    text-align: right !important;
}



:deep(.detail-table2 tbody td:nth-child(3)),
:deep(.detail-table2 tbody td:nth-child(4)),
:deep(.detail-table2 tbody td:nth-child(5)),
:deep(.detail-table2 tbody td:nth-child(6)),
:deep(.detail-table2 tbody td:nth-child(7)),
:deep(.detail-table2 tbody td:nth-child(8)) {
    text-align: right !important;
}

/* 메인 테이블 숫자 컬럼 오른쪽 정렬 */
.custom-datepicker {
    width: 150px; /* 원하는 너비 조정 */
    height: 35px;
    border-radius: 10px;
    top: 1px;
    text-align: center;
    font-size: 14px;
}

/* ✅ Datepicker 드롭다운 크기 조절 */
:deep(.dp__menu_inner) {
    width: 260px !important; /* ✅ 너비 조정 */
    font-size: 14px !important; /* ✅ 폰트 크기 조정 */
}
:deep(.dp__main) {
    background-color: transparent !important;
    box-shadow: none !important; /* ✅ 그림자도 제거 */
    border: none !important; /* ✅ 테두리 제거 */
}
:deep(.dp_input){
    height: 500px !important;
    padding-bottom: 10px !important;
}
@font-face {
    font-family: 'HyundaiSans2';
    src: url('../../assets/fonts/HyundaiSansHeadKRMedium.woff2') format('woff2');
    font-weight: normal;
    font-style: normal;
}
@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSans';
    src: url('../../assets/fonts/HYUNDAISANSHEADKRLIGHT.TTF') format('truetype');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRREGULAR.TTF') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRMEDIUM.TTF') format('truetype');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'HyundaiSansText';
    src: url('../../assets/fonts/HYUNDAISANSTEXTKRBOLD.TTF') format('truetype');
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: 'Gothic';
    src: url('../../assets/fonts/NanumGothic-Bold.ttf') format('truetype');
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: 'hyundai2';
    src: url('../../assets/fonts/hundai-M.ttf') format('truetype');
    font-weight: bold;
    font-style: normal;
}
@font-face {
    font-family: 'hyundai';
    src: url('../../assets/fonts/hyundai-L.ttf') format('truetype');
    font-style: normal;
}
/* ✅ 전체 애플리케이션의 기본 폰트로 적용 */
* {
    font-family: 'hyundai' !important;
}





/* ✅ 추가적인 Vuetify 내부 요소 폰트 적용 */

:deep(.dp__input) {
    width: 150px !important;
    height: 45px !important;
    border-radius: 5px !important;
    padding: 5px 2px !important;
    text-align: center !important;
    font-size: 14px !important;
    border-top-left-radius: 0% !important;
        border-bottom-left-radius: 0% !important;
        border-top-right-radius: 4px !important;
        border-bottom-right-radius: 4px !important;
}
.po-details-title {
    font-size: 22px;
    font-weight: bold;
    color: #333; /* 진한 색상 */
    text-align: center;
    margin-bottom: 10px;

}

.split-box1 {
  
  display: flex;
  width: 38vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.split-box2 {
  margin-left: 5vh;
  display: flex;
  width: 38vh;
  height: 45px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  overflow: hidden; /* 둥근 모서리 유지 */
  font-size: 16px;
}

.label-box {
  background-color: #f4f4f4; /* 🔵 라벨 배경색 */
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border-right: 1px solid #d1d5db;
}

.select-box {
  flex: 1;
  padding-left: 16px;
  display: flex;
  align-items: center;
  color: #374151;
  font-weight: bold;
  background-color: white;
}
.date-label-box {
  background-color: #f4f4f4;
  height: 45px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #374151;
  white-space: nowrap;
  border: 1px solid #d1d5db;
  border-radius: 4px 0 0 4px;
  border-right: none;
  top: 1;
}
.startDate {
  margin-left: 0px !important; /* ✅ 강제 제거 */
}
.dp_main{
    margin-left: 0px;
}
.custom-card-title {
  background-color: #6ea6d9; /* 파란 배경 */
  color: white;
  font-weight: bold;
  font-size: 18px;
  padding: 6px 20px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  text-align: left;
  position: relative;  /* ✅ z-index 작동을 위해 필요 */

  z-index: 50 !important;
}

.table-border-wrapper {
  border: 2px solid rgb(150, 150, 150);
  border-radius: 4px;
  overflow: hidden;
}
/* scoped CSS에 아래 추가 */
.lift-up {
  margin-top: -1px;
  z-index: 1;
  position: relative;  /* ✅ z-index 작동을 위해 필요 */

}
.container-fluid {
  height : 92%;
  overflow-y: auto;
}
:deep() .v-data-table tbody tr:nth-child(even) {
  background-color: #f5f5f5 !important; /* 짝수 행 연한 회색 */
}

:deep() .v-data-table tbody tr:nth-child(odd) {
  background-color: white !important; /* 홀수 행 흰색 */
}
</style>
